<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || closeDialog()"
    >
      <v-card>
        <v-card-title class="card-title">
          <span class="headline white--text text-uppercase">Block Asset</span>
        </v-card-title>
        <v-card-text>
          <p>Möglichkeit Payouts für User zu blockieren.</p>
          <ul>
            <li>
              <b>Historisch</b>: User muss die Anleihe jetzt nicht mehr besitzen. <br>
              (Wichtig bei Finanzierungsprojekten)
            </li>
            <li>
              <b>Normal</b>: Betrifft alle User die zurzeit Anleihen dieses Assets halten
            </li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="submit(true)"
          >
            historischer block
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="submit(false)"
          >
            normaler block
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'BlockAsset',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    asset: {
      type: Object,
      default: () => {},
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      show: this.dialog,
    };
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
    data(val) {
      this.amount = val.amount;
    },
  },
  methods: {
    submit(historic) {
      this.submitAction({
        id: this.asset.id,
        historic,
      });
    },
    closeDialog() {
      this.cancelAction();
    },
  },
};
</script>

<style lang="scss" scoped>
  .saldo-info {
    width: 90%;
    margin: 5px auto auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/baader/BlockAsset.vue